import { IntlContextProps } from './IntlProviderWrapper';
import { PageMessages } from './locales/types';

let intlRef: Partial<IntlContextProps> | null = null;

export function setIntlRef(ref: Partial<IntlContextProps>) {
  intlRef = ref;
}

export function getIntlRef(): Partial<IntlContextProps> {
  if (!intlRef) throw new Error("IntlRef has not been initialized yet.");
  return intlRef;
}

export function t<K extends keyof PageMessages>(key: K): string {
  const messages = getIntlRef().messages!;
  return messages[key] || '';
}